import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquareXTwitter, faSquareFacebook, faSquareInstagram, faWhatsappSquare } from '@fortawesome/free-brands-svg-icons';
import '../styles/footer.css';

// Category data with exact values and wording from Product.tsx and CreateDealForm.tsx
const categories = [
  { slug: 'men', name: 'Men\'s Clothing' },
  { slug: 'women', name: 'Women\'s Clothing' },
  { slug: 'kids', name: 'Kids Clothing' },
  { slug: 'books', name: 'Books & Education' },
  { slug: 'eid', name: 'Eid & Ramadan Specials' },
  { slug: 'finance', name: 'Islamic Finance' },
  { slug: 'food', name: 'Halal Food & Groceries' },
  { slug: 'health', name: 'Health & Wellness' },
  { slug: 'international', name: 'International' },
  { slug: 'local', name: 'Local (In-store)' },
  { slug: 'perfumes', name: 'Perfumes & Attar' },
  { slug: 'prayer', name: 'Prayer Essentials' },
  { slug: 'tech', name: 'Tech & Electronics' },
  { slug: 'toys', name: 'Toys & Games' },
  { slug: 'travel', name: 'Travel, Hajj, Umrah' },
  { slug: 'wedding', name: 'Wedding' },
  { slug: 'other', name: 'Other' }
];

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footerContent">
        <div className="footerColumns">
          <div className="footerColumn">
            <h3>Quick Links</h3>
            <div className="footerLinks">
              <Link to="/">Home</Link>
              <Link to="/about">About</Link>
              <Link to="/contact">Contact</Link>
              <Link to="/privacy">Privacy Policy</Link>
              <Link to="/terms">Terms of Service</Link>
            </div>
          </div>
          
          <div className="footerColumn">
            <h3>Browse Categories</h3>
            <div className="footerLinks categoryLinks">
              {categories.map(category => (
                <Link 
                  key={category.slug} 
                  to={`/category/${category.slug}`}
                >
                  {category.name}
                </Link>
              ))}
            </div>
          </div>
        </div>
        
        {/* Add the affiliate disclosure here */}
        <div className="affiliateDisclosure">
          * Our recommendations are impartial and based on our community's evaluations. However, 
          some external links on this site are affiliate links meaning we may earn a commission if 
          you make a purchase through these links. For full transparency, we encourage you to assume that every external link 
          is an affiliate link.
          <div className="readMoreLink">
            <Link to="/terms" onClick={() => window.scrollTo(0, 0)}>Read more here</Link>
          </div>
        </div>
        
        {/* Social Media Icons */}
        <div className="socialMediaIcons">
          <a 
            href="https://twitter.com/islamicdeals" 
            target="_blank" 
            rel="noopener noreferrer"
            aria-label="Follow us on X (Twitter)"
          >
            <FontAwesomeIcon icon={faSquareXTwitter} />
          </a>
          <a 
            href="https://instagram.com/islamicdeals" 
            target="_blank" 
            rel="noopener noreferrer"
            aria-label="Follow us on Instagram"
          >
            <FontAwesomeIcon icon={faSquareInstagram} />
          </a>
          <a 
            href="#" 
            className="facebook-icon"
            aria-label="Follow us on Facebook"
          >
            <FontAwesomeIcon icon={faSquareFacebook} />
          </a>
          <a 
            href="https://whatsapp.com/channel/0029VbA3pJYFi8xUjIOKVx08" 
            target="_blank" 
            rel="noopener noreferrer"
            aria-label="Join our WhatsApp channel"
          >
            <FontAwesomeIcon icon={faWhatsappSquare} />
          </a>
        </div>
        
        <div className="copyright">
          &copy; {currentYear} Islamic Deals. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;